import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../config/axiosApi/axiosApi.jsx";
import Preloader from "../../components/CustomComponents/preLoad/preLoader.js";
import APIs from "../../Constants/apis.js";
import showErrorToast, { showSuccessToast } from "../../components/CustomComponents/toast/toast.js";
import MarketplaceRiderForm from "./marketplaceRiderForm.jsx";

const UpdateMarketplaceRider = () => {
  const navigate = useNavigate();
  const { riderId } = useParams();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [rider, setRider] = useState(null);

  const fetchRider = useCallback(async () => {
    const id = Number(riderId);
    if (!id) {
      showErrorToast("Invalid rider id");
      navigate("/marketplaceRider/manageRiders");
      return;
    }
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_MARKETPLACE_RIDER_BY_ID, { params: { ID: id } });
      if (response.data?.status && response.data.data) {
        setRider(response.data.data);
      } else {
        showErrorToast(response.data?.message || "Failed to load rider");
        navigate("/marketplaceRider/manageRiders");
      }
    } catch {
      showErrorToast("Failed to load rider");
      navigate("/marketplaceRider/manageRiders");
    } finally {
      setLoading(false);
    }
  }, [riderId, navigate]);

  useEffect(() => {
    fetchRider();
  }, [fetchRider]);

  const handleSubmit = async (payload) => {
    try {
      setSaving(true);
      const response = await axiosInstance.post(APIs.POST_UPSERT_MARKETPLACE_RIDER, payload);
      if (response.data?.status) {
        showSuccessToast("Rider updated");
        navigate("/marketplaceRider/manageRiders");
      } else {
        showErrorToast(response.data?.message || response.data?.Message || "Save failed");
      }
    } catch (err) {
      showErrorToast(err.response?.data?.message || err.response?.data?.Message || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  const displayName = rider
    ? rider.name || `${rider.firstName || ""} ${rider.lastName || ""}`.trim() || `Rider #${riderId}`
    : `Rider #${riderId}`;

  return (
    <div>
      {(loading || saving) && <Preloader />}

      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
            <li className="breadcrumb-item"><Link to="/marketplaceRider/manageRiders">Go Fatafat Riders</Link></li>
            <li className="breadcrumb-item active">Update Rider</li>
          </ol>
          <h1 className="page-header mb-0">Update Rider</h1>
          <p className="text-muted mb-0 mt-1">
            {loading ? "Loading rider details…" : `Editing ${displayName}`}
          </p>
        </div>
      </div>

      <div className="card border-0">
        <div className="card-body p-3 p-md-4">
          {!loading && rider && (
            <MarketplaceRiderForm
              rider={rider}
              onSubmit={handleSubmit}
              onCancel={() => navigate("/marketplaceRider/manageRiders")}
              submitting={saving}
            />
          )}
          {!loading && !rider && (
            <div className="text-center text-muted py-5">Rider not found.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateMarketplaceRider;
